/**
 * The Snoozed or Settled header in Recents: its name, the fold chevron, and
 * its count in the times' column. While a filter is on it only labels the
 * matches, since every shelf shows them all. A level-1 item of Recents' tree,
 * holding its tab stop when it is the last item focused or the first item.
 *
 * @module components/home/RecentsShelfHeader
 */
import { ChevronRightIcon } from "lucide-react";

import { cn } from "~/lib/utils";

export function RecentsShelfHeader({
  label,
  count,
  open,
  filtering,
  onToggle,
  tabIndex,
  onFocus,
}: {
  readonly label: string;
  readonly count: number;
  readonly open: boolean;
  readonly filtering: boolean;
  readonly onToggle: () => void;
  readonly tabIndex: number;
  readonly onFocus: () => void;
}) {
  if (filtering) {
    return (
      <li
        role="treeitem"
        aria-level={1}
        tabIndex={tabIndex}
        onFocus={onFocus}
        className="flex h-7 list-none items-center gap-1 px-2.5 pt-2 text-xs text-sidebar-muted-foreground/70"
      >
        <span>{label}</span>
        <span className="tabular-nums opacity-70">{count}</span>
      </li>
    );
  }
  return (
    <li role="none" className="list-none pt-2">
      <button
        type="button"
        role="treeitem"
        aria-level={1}
        aria-expanded={open}
        tabIndex={tabIndex}
        onFocus={onFocus}
        onClick={onToggle}
        className="group/shelf flex h-7 w-full items-center gap-1 rounded-md px-2.5 text-left text-xs text-sidebar-foreground/56"
      >
        <span>{label}</span>
        <ChevronRightIcon strokeWidth={1.75} className={cn("size-3 opacity-60 transition-transform", open && "rotate-90")} />
        <span className="ms-auto tabular-nums">{count}</span>
      </button>
    </li>
  );
}
